<template>
    <modal @close="$emit('close')">
        <div
            class="preview-notification-container"
            slot="content"
        >
            <header>
                <img
                    :src="avatar"
                    class="avatar"
                >

                <h4>
                    Upmood
                </h4>

                <p>
                    {{ dateTime }}
                </p>
            </header>

            <section>
                <h4>
                    {{ title }}
                </h4>

                <p>
                    {{ description || '--' }}
                </p>
            </section>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/utils/Modal.vue'

export default {
	props: {
		avatar: {
			type: String,
			default: ''
		},

		date: {
			type: String,
			default: ''
		},

		time: {
			type: String,
			default: ''
		},

		title: {
			type: String,
			default: ''
		},

		description: {
			type: String,
			default: ''
		}
	},

	computed: {
		dateTime () {
			if (!this.time && !this.date) return '--'

			const { filters } = this.$options
			const timeFormatted = filters.dateFormatter(this.time, 'hh:mm:ss A')
			return `${filters.dateFormatter(this.date, 'MMM D, YYYY')} ${timeFormatted}`
		}
	},

	components: {
		Modal
	}
}
</script>

<style lang="scss" scoped>
.preview-notification-container {
    width: 400px;
    min-height: 300px;
    padding: 20px;
    border-radius: 10px;
    background-color: #fff;

    header {
        @include flex-row(stretch, center);
        margin-bottom: 20px;

        .avatar {
            width: 50px;
            height: 50px;
        }

        h4 {
            flex: 1 1 auto;
            margin: 0 10px;
        }

        p {
            font-size: .8em;
        }
    }

    section {
        h4 {
            margin-bottom: 20px;
        }
    }
}
</style>
